import { render, staticRenderFns } from "./remarkDialog.vue?vue&type=template&id=02cbec49&"
import script from "./remarkDialog.vue?vue&type=script&lang=js&"
export * from "./remarkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports